<template>
  <mChartDom :option="getOps" />
</template>

<script>
import mChartDom from "./mChartDom";

export default {
  components: {
    mChartDom
  },
  name: "mPie",
  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    option: {
      type: Object,
      default: () => ({})
    },

  },
  data() {
    return {
      defaultOption: {
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          right: "10%",
          top: "middle",
          itemWidth: 10,
          itemHeight: 10,
          borderRadius: [10, 10, 10, 10],
          icon: "circle",
          textStyle: {
            fontSize: 13,
            rich: {
              a: {
                verticalAlign: "right",
                fontSize: 12,
                align: "left",
                // padding:[0,28,0,0],
                // width: 40
              },
              b: {
                fontSize: 12,
                align: "left",
                padding: [0, 20, 0, 20],
                // width: 50

              },
              c: {
                fontSize: 12,
                align: "left",
                color: "#ccc",
                // width: 50
              }
            }
          },
          tooltip: {
            show: true
          },
          formatter: (name) => {
            const value = this.data.find(el => el.name === name)?.value;
            // return `${name} | ${this.percentage(value)} | ${value}人`;


            return [
              `{a| ${name}}`,
              `{b| ${this.percentage(value)}}`,
              `{c| ${value}}`
            ].join("");

          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ['40%', '70%'],
            center: ["25%", "50%"],
            label: {
              show: false
            },
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      myChart: undefined
    };
  },
  methods: {
    getDataTotal() {
      return this.data.reduce((acc, cur) => acc + cur.value, 0);
    },
    percentage(value) {
      if (!value) return "0.00%";
      return `${(value / this.getDataTotal() * 100)?.toFixed(2)}%` || "0%";
    }
  },
  computed: {
    getOps() {
      const { series } = this.defaultOption;
      const [first] = series;
      first.data = this.data;
      return {
        ...this.defaultOption,
        ...this.option
      };
    }
  }
};
</script>

<style scoped>
#mPie {
  min-width: 100px;
  min-height: 100px;
  height: 100%;
}
</style>
